import { FunctionComponent, ReactNode } from 'react'
import useIsInUltraModuleBundling from '@hooks/useIsInUltraModuleBundling'
import styled, { css } from 'styled-components'
import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import useShowBundling from '@hooks/useShowBundling'

interface MainItemWrapperProps {
  children: ReactNode
  accentColor?: string
}

const StyledMainItemWrapper = styled.div<
  Pick<MainItemWrapperProps, 'accentColor'>
>`
  ${({
    theme: {
      colors: { staticRed500 },
      spacing: { spacing8 },
      measures: { stretchWidthOnMobile },
    },
    accentColor,
  }) => css`
    position: relative;
    grid-column: 1 / -1;
    ${desktopCSS(css`
      border-left: 15px solid ${accentColor ?? staticRed500};
      margin-left: -15px;
    `)};

    ${mobileAndTabletCSS(css`
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;

        width: 8px;
        height: calc(100% - ${spacing8});

        ${stretchWidthOnMobile};

        background: ${accentColor ?? staticRed500};
      }
    `)};
  `}
`

const MainItemWrapper: FunctionComponent<MainItemWrapperProps> = ({
  children,
  accentColor,
}) => {
  const hasBundling = useIsInUltraModuleBundling()
  const shouldShowBundling = useShowBundling() && hasBundling
  if (!shouldShowBundling) {
    return children
  }

  return (
    <StyledMainItemWrapper accentColor={accentColor}>
      {children}
    </StyledMainItemWrapper>
  )
}

export default MainItemWrapper
